import { createHash } from 'node:crypto';
import { getAgentInputItemKey } from '../runner/items';
import type { AgentInputItem } from '../types';
import type { HistoryItemRef } from './types';

export type StableHistoryItem = {
  id: HistoryItemRef;
  index: number;
  item: AgentInputItem;
};

export function buildStableHistoryItems(
  items: AgentInputItem[],
): StableHistoryItem[] {
  return items.map((item, index) => ({
    id: getStableHistoryItemRef(item, index),
    index,
    item,
  }));
}

export function getStableHistoryItemRef(
  item: AgentInputItem,
  index: number,
): HistoryItemRef {
  if (item && typeof item === 'object') {
    const id = (item as { id?: unknown }).id;
    if (typeof id === 'string' && id.length > 0) {
      return id;
    }
  }
  return `idx:${index}:sha256:${fingerprintItem(item)}`;
}

function fingerprintItem(item: AgentInputItem): string {
  return createHash('sha256')
    .update(getAgentInputItemKey(item))
    .digest('hex')
    .slice(0, 16);
}
